import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) { setErr(formatApiError(e2.response?.data?.detail) || e2.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-app max-w-md mx-auto px-6 pt-16">
      <div className="overline">Reset password</div>
      <h1 className="font-display text-4xl uppercase mt-3">Forgot?</h1>
      {sent ? (
        <div className="mt-8 space-y-4" data-testid="forgot-sent">
          <div className="card p-4">
            <div className="overline">Check your inbox</div>
            <p className="text-t2 text-sm mt-2">If <span className="text-t1">{email}</span> is on file, we sent a reset link. Links expire in 1 hour.</p>
          </div>
          <Link to="/login" className="btn btn-outline w-full">Back to sign in</Link>
        </div>
      ) : (
        <form className="mt-8 space-y-4" onSubmit={submit}>
          <p className="text-t2 text-sm">Enter your email. We'll send a link to set a new password.</p>
          <input className="input" placeholder="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
          {err && <div className="text-red text-sm">{err}</div>}
          <button className="btn btn-primary w-full" disabled={loading} data-testid="forgot-submit">{loading ? "…" : "Send reset link"}</button>
        </form>
      )}
      <div className="mt-8 text-center text-sm text-t2">Remembered? <Link to="/login" className="text-lime">Sign in</Link></div>
    </div>
  );
}
